import BaseXMLGenerator from '@/utils/excel/xlsx-tableexport-generator.js'
import { getOrderID, amountFormat } from '@/utils/filters/formatter.js'

function amountFormatBySDK (value) {
  return value
  // return amountFormat(value)
}

var XMLGenerator = new BaseXMLGenerator()
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
  var rows = []
  for (var dataIdx = 0; dataIdx < datas.length; dataIdx++) {
    let data = datas[dataIdx]
    var row = []

    var username = data.Username ||
    (data.FBID != '' ? 'FB登入' : null) ||
    (data.LineID != '' ? 'Line登入' : null) ||
    (data.AppleID != '' ? 'Apple登入' : null) ||
    (data.GoolgeID != '' ? 'Google登入' : null)

    row.push(data.Profile.Name)
    row.push(username)
    row.push(data.Detail.OrderCount)
    row.push(data.Detail.OrderAmountSum)
    row.push(data.Detail.VoucherAmount)
    row.push(data.Detail.LastLoginedAt)

    rows.push(row)
  }

  let headerList = ['名稱', '帳號', '訂單數量', '累積金額', '購物金', '最後登入時間']
  let typeList = [
    'string', 'string', 'number', 'number', 'number', 'string'
  ]
  return this.baseGenerate(rows, headerList, typeList)
}

export default XMLGenerator
